// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CAvQh","rootMobile":"styles_rootMobile__2aT57"};